import React from 'react';
import CargaTarjeta from '../../comun/CargaTarjeta';

/**
 * Tarjeta «Retiros y dividendos» del AT 2026: el Excel «Detalle_DJ_1948» que el SII
 * entrega a la persona en Información de terceros, con los retiros de su propia empresa y
 * de otras donde participa. Se guardan todas las columnas del archivo; aquí se muestran
 * las principales. Su lector está en
 * src/services/declaracionRenta/empresarioIndividual/2026/retiros/lector.js
 */
const COLUMNAS = [
  { campo: 'seccion', titulo: 'Sección' },
  { campo: 'nombre_declarante', titulo: 'Empresa' },
  { campo: 'rut_declarante', titulo: 'RUT empresa' },
  { campo: 'fecha_retiro', titulo: 'Fecha retiro', formato: 'fecha' },
  { campo: 'afecto_credito_idpc_desde_2017', titulo: 'Retiro con crédito IDPC desde 2017', monto: true },
  { campo: 'afecto_credito_idpc_hasta_2016', titulo: 'Retiro con crédito IDPC hasta 2016', monto: true },
  { campo: 'afecto_sin_credito', titulo: 'Retiro sin crédito', monto: true },
  { campo: 'credito_2017_no_sujeto_desde_2020_sin_devolucion', titulo: 'Crédito no sujeto a restitución desde 2020, sin devolución', monto: true },
  { campo: 'credito_2017_no_sujeto_desde_2020_con_devolucion', titulo: 'Crédito no sujeto a restitución desde 2020, con devolución', monto: true },
  { campo: 'credito_2017_sujeto_restitucion_sin_devolucion', titulo: 'Crédito sujeto a restitución, sin devolución', monto: true },
  { campo: 'credito_2017_sujeto_restitucion_con_devolucion', titulo: 'Crédito sujeto a restitución, con devolución', monto: true },
  { campo: 'monto_retiro_exceso', titulo: 'Retiro en exceso', monto: true },
  { campo: 'numero_certificado', titulo: 'N° certificado' },
];

const RetirosPage = ({ anioTributario, idCompany }) => (
  <CargaTarjeta
    anioTributario={anioTributario}
    idCompany={idCompany}
    tarjeta="retiros"
    columnas={COLUMNAS}
    extensiones=".xls,.xlsx"
    ayuda={(
      <>
        Sube el Excel <strong>Detalle_DJ_1948_{anioTributario}00_&lt;RUT&gt;.xlsx</strong> que descargas del SII en
        Información de terceros: los retiros, remesas y dividendos que te informaron las empresas, la tuya y otras
        donde participas, con sus créditos (Sección B) y los retiros en exceso (Sección C). Se guardan todas las
        columnas del archivo. El archivo no se guarda.
      </>
    )}
  />
);

export default RetirosPage;
